import { call, put, takeLatest } from "redux-saga/effects";
import {
    GET_LIVE_BOOKINGS_REQUEST,
    getLiveBookingsSuccess,
    getLiveBookingsFailure,
    reassignTripSuccess,
    reassignTripFailure,
    REASSIGN_TRIP_REQUEST,
    autoCompleteSuccess,
    autoCompleteFailure,
} from "../actions/liveAction";
import { autoCompleteApi, getLiveBookingsApi, reassignTripApi } from "../../utils/booking/Live";

function* getLiveBookings(action: any): Generator<any, void, any> {
    try {
        const { branchid, filtervalue } = action.payload;

        const response = yield call(
            getLiveBookingsApi,
            branchid,
            filtervalue
        );

        yield put(getLiveBookingsSuccess(response.data.data));
    } catch (error: any) {
        yield put(
            getLiveBookingsFailure(
                error.response?.data?.message || error.message
            )
        );
    }
}

function* reassignTripSaga(action: any): any {
    try {
        const response = yield call(reassignTripApi, action.payload);

        const { status, message, data } = response.data;

        if (status === 200) {
            yield put(
                reassignTripSuccess({
                    message,
                    data,
                })
            );
        } else {
            yield put(reassignTripFailure(message));
        }
    } catch (error: any) {
        yield put(
            reassignTripFailure(
                error?.response?.data?.message ||
                "Failed to reassign trip"
            )
        );
    }
}

function* autoCompleteSaga(action: any): any {
    try {
        const response = yield call(autoCompleteApi, action.payload);

        yield put(autoCompleteSuccess(response.data));
    } catch (error: any) {
        yield put(
            autoCompleteFailure(
                error.response?.data || {
                    message: error.message,
                }
            )
        );
    }
}

export default function* liveSaga() {
    yield takeLatest(GET_LIVE_BOOKINGS_REQUEST, getLiveBookings);
    yield takeLatest(REASSIGN_TRIP_REQUEST, reassignTripSaga);
    yield takeLatest("AUTO_COMPLETE_REQUEST", autoCompleteSaga);
}